import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom' // 1. Import useLocation
import { getDoctorProfile } from '../../service/operations/api_methods'
import Cookies from "js-cookie";
const Header = () => {
    const navigate = useNavigate()
    const location = useLocation() // 2. Use the hook to track current page
    const currentPath = location.pathname;
    const [modal,setModal]=useState(false)
       const[data,setData]=useState(null)
       const token = Cookies.get("token")

    const handleGetProfile =async()=>{
      try {
        const res= await getDoctorProfile(token)
        console.log(res);
        if(res.status===200){
          setData(res.data.data)
        }
        
      } catch (error) {
        console.log(error);
        
      }
    }
    useEffect(() => {
      handleGetProfile()
    }, [])

  return (
    <div className='w-full fixed top-0 z-50' style={{height:"85px", background: "linear-gradient(90deg, #c2ebf8ff, #ffffffff, #c1eafaff)",padding:"0px 26px"}}>
     
     {/* Logic: If at Root (Login), show center logo. Else, show full Nav */}
     {currentPath === "/" ? 
      (
      <div className='flex items-center justify-center  p-4 border-black'>
        <p onClick={()=>setModal(!modal)} style={{fontSize:"26px",fontWeight:"700",cursor:"pointer"}}> Swasthya Khata (Doctor)</p>
      </div>
      ) 
      : 
      (
      <div className='flex items-center justify-between  p-4 border-black'>
        
        {/* LOGO: Clicking this takes you back to Dashboard */}
        <p onClick={()=>navigate('/dashboard')} style={{fontSize:"26px",fontWeight:"700",cursor:"pointer"}}>Swasthya Khata (Doctor)</p>

          {currentPath!=="/dashboard"&& 
           <div className='flex items-center justify-center gap-6'>
                {/* --- ADDED DASHBOARD LINK HERE --- */}
                {/* This ensures users can easily return if they are on "Find Hospitals" pages */}
                {/* <p onClick={()=>navigate('/dashboard')}
                    className='cursor-pointer text-gray-500 font-bold hover:text-blue-600 transition-colors'>
                    Dashboard
                </p> */}

                <p onClick={()=>navigate('/find-hospitals')}
                    className='cursor-pointer text-gray-500 font-bold hover:text-blue-600 transition-colors'>
                    Find Hospitals
                </p>
                
                <p onClick={()=>navigate('/find-diagonistics')}
                    className='cursor-pointer text-gray-500 font-bold hover:text-blue-600 transition-colors'>
                    Find Diagonistic
                </p>
                
                <p onClick={()=>navigate('/request')}
                    className='cursor-pointer text-gray-500 font-bold hover:text-blue-600 transition-colors'>
                    Request
                </p>
                
                <p onClick={()=>navigate('/patients')}
                    className='cursor-pointer text-gray-500 font-bold hover:text-blue-600 transition-colors'>
                    Patients
                </p>
            </div>}

        <p onClick={()=>setModal(!modal)}
        style={{padding:"8px",backgroundColor:"#226df8ff",fontSize:"15px",borderRadius:"10px",color:"white",fontWeight:"700",cursor:"pointer"}}>
          Account
        </p>

      </div>
      )}

      {modal && 
      <div style={{position:"fixed",top:"80px",right:"30px",width:"100px",height:"100px",backgroundColor:"#fefefe",zIndex:9999999}}> 
         <div style={{padding:"14px"}}>
        <p style={{fontSize:"18px",fontWeight:600,display:"flex",alignItems:"center",gap:"20px"}}>
          <span><img src='/Assets/hospital-user.png'/></span>
          {data?.hospital_name}</p>
        <div style={{borderTop:"1px solid grey",margin:"10px 1px"}}>
         <p style={{fontSize:"14px",fontWeight:"600",}}>License:{data?.license_number}</p>
          <p style={{fontSize:"14px",fontWeight:"600",}}>Address:{data?.address}</p>
          </div>
        </div>
        </div>}
    </div>
  )
}

export default Header